import { forwardRef } from "react";

import Icon from "@/components/Icon";
import RawArticleIcon from "./RawArticleIcon.svg.jsx";

const ArticleIcon = forwardRef((props, ref) => {
  return (
    <Icon
      ref={ref}
      SvgComponent={RawArticleIcon}
      data-testid="article-icon"
      {...props}
    />
  );
});

export default ArticleIcon;
